export default "__VITE_ASSET__q1_XRVBM__"